import User from '../../models/user';

export const LOAD_USERS = 'LOAD_USERS';
export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USERS = 'DELETE_USERS';

export function loadUsers() {
  return {
    type: LOAD_USERS,
    payload: {},
  };
}

export function updateUser(user: User) {
  return {
    type: UPDATE_USER,
    payload: { user },
  };
}

export function deleteUsers() {
  return {
    type: DELETE_USERS,
    payload: {},
  };
}
